import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useEffect, useRef } from 'react';
import { login } from '../api/auth';
import { ASSETS } from '../config/assets';
export function LoginPage({ showPw, loginLoading, loginError, onTogglePw, onSuccess, onLoading, onError, }) {
    const emailRef = useRef(null);
    const pwRef = useRef(null);
    const mcpSlotRef = useRef(null);
    const mcpHostRef = useRef(null);
    const mcpPlaceholderRef = useRef(null);
    useEffect(() => {
        const host = document.getElementById('agent-mcp-host');
        const slot = mcpSlotRef.current;
        if (!host || !slot || host.parentElement === slot)
            return;
        mcpHostRef.current = host;
        const placeholder = document.createComment('agent-mcp-host');
        host.parentElement?.insertBefore(placeholder, host);
        mcpPlaceholderRef.current = placeholder;
        slot.appendChild(host);
        return () => {
            const h = mcpHostRef.current;
            const ph = mcpPlaceholderRef.current;
            if (h && ph?.parentNode) {
                ph.parentNode.insertBefore(h, ph);
                ph.remove();
            }
            mcpHostRef.current = null;
            mcpPlaceholderRef.current = null;
        };
    }, []);
    const handleSubmit = async (e) => {
        e.preventDefault();
        if (loginLoading)
            return;
        const email = emailRef.current?.value.trim() ?? '';
        const password = pwRef.current?.value ?? '';
        if (!email) {
            onError('Введите email');
            return;
        }
        onError('');
        onLoading(true);
        try {
            const user = await login(email, password);
            onSuccess(user);
        }
        catch {
            onError('Неверный email или пароль');
        }
        finally {
            onLoading(false);
        }
    };
    return (_jsxs("div", { style: {
            minHeight: '100vh',
            background: '#F8FAFC',
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            justifyContent: 'center',
            gap: 22,
            padding: 24,
        }, children: [_jsxs("div", { style: { display: 'flex', flexDirection: 'column', alignItems: 'center', gap: 10 }, children: [_jsx("img", { src: ASSETS.logo, alt: "\u041A\u0432\u0430\u0440\u0442\u0430\u043B\u044C\u043D\u044B\u0439 \u043F\u043B\u0430\u043D", style: { width: 48, height: 48 } }), _jsx("div", { style: { fontSize: 21, fontWeight: 700, letterSpacing: '-0.01em' }, children: "\u041A\u0432\u0430\u0440\u0442\u0430\u043B\u044C\u043D\u044B\u0439 \u043F\u043B\u0430\u043D" }), _jsx("div", { style: { fontSize: 12.5, color: '#64748B', marginTop: -6 }, children: "Digital Command \u00B7 roadmap" })] }), _jsxs("form", { onSubmit: handleSubmit, style: {
                    width: 368,
                    maxWidth: '92vw',
                    background: '#FFFFFF',
                    border: '1px solid #E2E8F0',
                    borderRadius: 12,
                    boxShadow: '0 1px 3px rgba(15,23,42,.06)',
                    padding: 24,
                    display: 'flex',
                    flexDirection: 'column',
                    gap: 14,
                }, children: [_jsxs("label", { style: { display: 'flex', flexDirection: 'column', gap: 6, fontSize: 12, fontWeight: 600, color: '#334155' }, children: ["Email", _jsx("input", { ref: emailRef, type: "email", placeholder: "name@company.ru", className: "kp-input", style: {
                                    height: 38,
                                    border: '1px solid #CBD5E1',
                                    borderRadius: 8,
                                    padding: '0 12px',
                                    fontSize: 14,
                                    width: '100%',
                                } })] }), _jsxs("label", { style: { display: 'flex', flexDirection: 'column', gap: 6, fontSize: 12, fontWeight: 600, color: '#334155' }, children: ["\u041F\u0430\u0440\u043E\u043B\u044C", _jsxs("div", { style: { position: 'relative', display: 'flex' }, children: [_jsx("input", { ref: pwRef, type: showPw ? 'text' : 'password', placeholder: "\u2022\u2022\u2022\u2022\u2022\u2022\u2022\u2022", className: "kp-input", style: {
                                            flex: 1,
                                            height: 38,
                                            border: '1px solid #CBD5E1',
                                            borderRadius: 8,
                                            padding: '0 84px 0 12px',
                                            fontSize: 14,
                                            width: '100%',
                                        } }), _jsx("button", { type: "button", onClick: onTogglePw, className: "kp-pw-toggle", style: {
                                            position: 'absolute',
                                            right: 6,
                                            top: 7,
                                            height: 24,
                                            border: 'none',
                                            background: 'none',
                                            color: '#2563EB',
                                            fontSize: 12,
                                            fontWeight: 600,
                                            cursor: 'pointer',
                                            padding: '0 6px',
                                            borderRadius: 5,
                                        }, children: showPw ? 'Скрыть' : 'Показать' })] })] }), loginError ? (_jsx("div", { style: {
                            background: '#FEF2F2',
                            border: '1px solid #FECACA',
                            color: '#B91C1C',
                            borderRadius: 8,
                            padding: '8px 12px',
                            fontSize: 12.5,
                        }, children: loginError })) : null, _jsxs("button", { type: "submit", disabled: loginLoading, className: "kp-login-btn", style: {
                            height: 40,
                            border: 'none',
                            borderRadius: 8,
                            background: '#2563EB',
                            color: '#FFFFFF',
                            fontSize: 14,
                            fontWeight: 600,
                            cursor: 'pointer',
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'center',
                            gap: 8,
                            opacity: loginLoading ? 0.7 : 1,
                        }, children: [loginLoading ? (_jsx("span", { style: {
                                    width: 14,
                                    height: 14,
                                    border: '2px solid rgba(255,255,255,.4)',
                                    borderTopColor: '#FFFFFF',
                                    borderRadius: '50%',
                                    animation: 'kp-spin .7s linear infinite',
                                } })) : null, _jsx("span", { children: loginLoading ? 'Вход…' : 'Войти' })] }), _jsx("div", { style: { fontSize: 11.5, color: '#94A3B8', textAlign: 'center' }, children: "\u0412\u0445\u043E\u0434 \u0447\u0435\u0440\u0435\u0437 API plan-backend" })] }), _jsx("div", { ref: mcpSlotRef, className: "kp-login-mcp-slot" }), _jsx("div", { style: { fontSize: 12, color: '#94A3B8' }, children: "\u00A9 \u0432\u043D\u0443\u0442\u0440\u0435\u043D\u043D\u0438\u0439 \u0441\u0435\u0440\u0432\u0438\u0441 \u00B7 plan.ershov.pw" })] }));
}
